import type {
  Announcement,
  AnnouncementFormPayload,
  AnnouncementListResult,
} from './announcementType';
import { del, get, post, put } from '../request';

const ANNOUNCEMENTS_API_PATH = '/api/announcements';

export async function fetchCurrentAnnouncementApi() {
  const result = await get<{ announcement: Announcement | null }>(`${ANNOUNCEMENTS_API_PATH}/current/`);
  return result.data;
}

export async function fetchAnnouncementListApi(params: { page?: number; page_size?: number; search?: string } = {}) {
  const result = await get<AnnouncementListResult>(`${ANNOUNCEMENTS_API_PATH}/`, params);
  return result.data;
}

export async function dismissAnnouncementApi(id: number) {
  const result = await post<{ id: number; version: number }>(`${ANNOUNCEMENTS_API_PATH}/${id}/dismiss/`);
  return result.data;
}

export async function fetchAnnouncementManageListApi(params: { page?: number; page_size?: number; status?: string; search?: string } = {}) {
  const result = await get<AnnouncementListResult>(`${ANNOUNCEMENTS_API_PATH}/manage/`, params);
  return result.data;
}

function buildAnnouncementFormData(payload: AnnouncementFormPayload) {
  const formData = new FormData();
  formData.append('title', payload.title);
  formData.append('content', payload.content);
  formData.append('link_url', payload.link_url);
  formData.append('starts_at', payload.starts_at || '');
  formData.append('ends_at', payload.ends_at || '');
  formData.append('is_pinned', String(payload.is_pinned));
  formData.append('sort_order', String(payload.sort_order));
  if (payload.image)
    formData.append('image', payload.image);
  if (payload.remove_image)
    formData.append('remove_image', 'true');
  return formData;
}

export async function createAnnouncementApi(payload: AnnouncementFormPayload) {
  const result = await post<{ announcement: Announcement }>(
    `${ANNOUNCEMENTS_API_PATH}/manage/`,
    buildAnnouncementFormData(payload),
  );
  return result.data;
}

export async function updateAnnouncementApi(id: number, payload: AnnouncementFormPayload) {
  const result = await put<{ announcement: Announcement }>(
    `${ANNOUNCEMENTS_API_PATH}/manage/${id}/`,
    buildAnnouncementFormData(payload),
  );
  return result.data;
}

async function actionAnnouncementApi(id: number, action: 'publish' | 'retract' | 'archive') {
  const result = await post<{ announcement: Announcement }>(`${ANNOUNCEMENTS_API_PATH}/manage/${id}/${action}/`);
  return result.data;
}

export const publishAnnouncementApi = (id: number) => actionAnnouncementApi(id, 'publish');
export const retractAnnouncementApi = (id: number) => actionAnnouncementApi(id, 'retract');
export const archiveAnnouncementApi = (id: number) => actionAnnouncementApi(id, 'archive');

export async function deleteAnnouncementApi(id: number) {
  const result = await del<{ id: number }>(`${ANNOUNCEMENTS_API_PATH}/manage/${id}/`);
  return result.data;
}
